import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Tooltip } from "@mui/material";
import {
  DeleteIcon,
  EditIcon,
  HistoryIcon,
  HistorySheet,
  PastHistoryInvestigations,
} from "./EmrCommonAsset/Asset";
import OPDPathologyModal from "./PathologyModal";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import { getInvestigationList } from "../services/EMRServices/emrServices";
import { useEMRGeneralContext } from "../newGeneralEmr/EMRContextGeneral";
import PastPathology from "./PastPathology";
import { warningAlert } from "../../../common/components/Toasts/CustomToasts";
import PathologyModal from "./PathologyModal";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { useFormContext } from "react-hook-form";
export default function Pathology(props) {
  const {
    pathologyData,
    setPathologyData,
    serviceData,
    setServiceData,
    dataPathology,
    setDataPathology,
    editData,
    markFavoriteData,
    patientHistoryData,
    setPatientHistoryData,
    setRadiologyData,
  } = props;
  const [investigationList, setInvestigationList] = useState([]);
  const [investigationChipsList, setInvestigationChipsList] = useState([]);
  const [selectedChips, setSelectedChips] = useState([]);
  const [chipsCount, setChipsCount] = useState(5);
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [openPathologyModal, setOpenPathologyModal] = useState(false);
  const [data, setData] = useState([]);
  const [selectedPathology, setSelectedPathology] = useState(null);
  const [save, setSave] = useState(false);
  const [edit, setEdit] = useState(false);
  const [row, setRow] = useState();
  const [index, setIndex] = useState();
  const [editOpen, setEditOpen] = useState(false);
  const [openPastPathology, setOpenPastPathology] = useState(false);
  const [isDeletedData, setIsDeletedData] = useState([]);
  const [tempDel, setTempDel] = useState(false);
  const [id, setId] = useState(null);
  const [investigationption, setInvestigationOptions] = useState([]);
  let userRole = JSON.parse(localStorage.getItem("loggedUser"));

  let defaultValues = {
    urgent: false,
  };
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  });

  function deleteRow(row, index) {
    let dataArray = [...pathologyData];

    if (dataArray?.length > 0) {
      for (let pathologyService of dataArray) {
        if (row?.serviceId === pathologyService?.serviceId) {
          pathologyService.isDeleteFlag = true;
        }
      }
      setPathologyData(dataArray);
    }

    let services = [...serviceData];

    if (services?.length > 0) {
      for (let service of services) {
        if (service?.serviceId === row?.serviceId) {
          service.isDeleteFlag = true;
        }
      }
      setServiceData(services);
    }
  }
  const mergeArray = (arr) => {
    return arr.reduce((acc, val) => {
      const ind = acc.findIndex((item) => item.service === val.service);
      if (ind !== -1) {
        console.log("Service Already Exists");
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  };
  const mergePathologyArray = (arr) => {
    return arr.reduce((acc, val) => {
      const ind = acc.findIndex((item) => item.serviceId === val.serviceId);
      if (ind !== -1) {
        console.log("Service Already Exists");
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  };
  useEffect(() => {
    // const combinedData2 = [...serviceData,...isDeletedData]

    const combinedData = [...pathologyData, ...isDeletedData];
    setPathologyData(mergeArray(combinedData));
    // setServiceData(combinedData2)
  }, [isDeletedData]);

  const filteredPathologyData =
    pathologyData?.filter((item) => item.isDeleteFlag === false) || [];

  const renderActions = (row, index) => {
    console.log("The rows in the pathology component are :", row);

    setId(props.row?.id);
    return (
      <div className="flex gap-2">
        {/* <Tooltip title="Edit">
          <button
            disabled={row?.id > 0}
            type="button"
            onClick={() => {
              setEditOpen(true);
              setEdit(true);
              setRow(row);
              setIndex(index);
            }}
          >
            <EditIcon />
          </button>
        </Tooltip> */}

        {!row?.isWorkOrderCreated === true && !row?.isBilled ? (
          <Tooltip title="Delete">
            <button
              disabled={row.orderId !== null && row.orderId !== undefined}
              type="button"
              onClick={() => {
                deleteRow(row, index);
              }}
            >
              <DeleteIcon />
            </button>
          </Tooltip>
        ) : (
          ""
        )}
      </div>
    );
  };

  useEffect(() => {
    if (save === true) {
      setPathologyData([...dataPathology]);
      setSave(false);
      setServiceData((prevState) =>
        mergeArray([...prevState, ...dataPathology]),
      );
    }
  }, [save]);
  function renderInput(row, index, header) {
    console.log("row999", row);

    return (
      <>
        {header === "Urgent" && (
          <>
            <input
              // disabled
              type="checkbox"
              name={`urgent${index}`}
              // checked={row.Urgent}
              onChange={(e) => {
                let tempData = [...pathologyData];
                tempData[index].urgent = e.target.checked;
                setPathologyData(tempData);
              }}
            />
          </>
        )}
      </>
    );
  }

  const handleChange = (e) => {
    if (e !== undefined && e !== "") {
      let pathologyObj = {
        testTypeId: 1,
        departmentId: props.patientVisitedDepartmentId,
        searchString: e,
        unitId: userRole.loginUnitId,
      };
      getInvestigationList(pathologyObj)
        .then((response) => {
          setInvestigationOptions(response.data.result);
        })
        .catch((response) => {
          console.log(response);
        });
    } else if (e === "" || e === undefined || e === null) {
      setInvestigationOptions([]);
    }
  };
  let investigation = watch("investigation");
  let urgent = watch("urgent");
  useEffect(() => {
    if (
      (investigation !== null && investigation !== undefined) ||
      selectedPathology !== null
    ) {
      let obj = {
        testId: investigation?.id || selectedPathology?.id,
        service: investigation?.label || selectedPathology?.serviceName,
        urgent: urgent,
        serviceId: investigation?.serviceId || selectedPathology?.serviceId,
        // id: id !== null ? id : null,
        isNew: true,
        isLab: true,
        isDeleteFlag: false,
        isTempDelete: false,
      };
      let temp = pathologyData.some(
        (item) =>
          item.service === investigation?.label ||
          selectedPathology?.serviceName,
      );

      if (temp === true) {
        warningAlert("Already Present Record..!");
      } else {
        // if (investigation !== null && investigation !== undefined) {
        setPathologyData((prevState) => [...prevState, obj]);
        setServiceData((prevState) => mergeArray([...prevState, obj]));
        setValue("investigation", null);
        setValue("urgent", false);
        // } else {
        //   warningAlert("Please Fill The Record");
        // }
      }
    }
  }, [investigation, selectedPathology]);

  return (
    <div>
      <div className="flex justify-between bg-[#DCFCE7] rounded-t-md w-full">
        <p className="text-sm font-semibold pl-2 py-2">Pathology</p>
        <div className=" w-[300px]  flex my-auto gap-2">
          {/* <button
            type="button"
            onClick={() => {
              setOpenPathologyModal(true);
              setSave(false);
            }}
          >
            <div className="flex justify-between border w-36 mx-2 bg-white">
              <p className="text-xs my-auto px-2">Pathology</p>
              <SearchIcon />
            </div>
          </button> */}
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            className="w-full"
          >
            <SearchDropdown
              // ref={selectRef}
              focused={true}
              control={control}
              // error={errors.allergyType}
              name="investigation"
              label="Investigation"
              placeholder="Investigation"
              dataArray={investigationption}
              isSearchable={false}
              handleInputChange={handleChange}
              // onInputChange={handleChange}
              menuPlacement="bottom"
              autoFocus
              searchIcon={true}
            />
          </fieldset>
          {/* <button
            type="button"
            onClick={() => {
              setOpenPastPathology(true);
              // setSave(false)
            }}
          >
            <HistoryIcon />
          </button> */}
        </div>
      </div>
      <div className=" border min-h-32 max-h-44 pb-2 overflow-auto border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        <div className="flex justify-between ">
          <div className="flex flex-wrap space-x-2 pl-2">
            {markFavoriteData?.Pathology &&
              markFavoriteData?.Pathology.slice(0, chipsCount).map(
                (item, index) => {
                  {
                    /* const isSelected = selectedChips.includes(item); */
                  }
                  return (
                    <div
                      key={index}
                      className={`mr-[5px] mb-1 capitalize h-[27px] px-3 w-max rounded text-sm border border-gray-300 whitespace-nowrap ${
                        pathologyData?.some(
                          (val) => val?.service === item.label,
                        )
                          ? "bg-[#32819b] text-white rounded-full border"
                          : "text-black rounded-full border"
                      }`}
                      disabled={pathologyData.some(
                        (val) => val?.investigation === item.label,
                      )}
                      onClick={() => {
                        // if (selectedChips.includes(item)) {
                        //   // setSelectedChips(
                        //   //   selectedChips.filter(
                        //   //     (selectedChip) => selectedChip !== item
                        //   //   )
                        //   // );
                        // } else {
                        //   setSelectedChips([...selectedChips, item]);
                        // }
                        setValue("investigation", item);
                        // setSelectedPathology(item);
                        // setOpenPathologyModal(true);
                      }}
                    >
                      {item.label}
                    </div>
                  );
                },
              )}
          </div>
        </div>

        {checkDuplicate === true ? (
          <p className="text-xs text-red-500"> Record Already Present</p>
        ) : (
          ""
        )}

        <>
          {filteredPathologyData?.length > 0 ? (
            <div className="0">
              <CommonTransactionTable
                dataResult={mergePathologyArray(filteredPathologyData).map(
                  (item) => ({
                    Investigation: item.service,
                    Urgent: item.urgent,
                    serviceId: item?.serviceId,
                    isLab: item.isLab,
                    isDeleteFlag: item?.isDeleteFlag,
                    id: item?.id,
                    testId: item?.testId,
                    status: item?.status,
                    isNew: item?.isNew,
                    isTempDelete: item?.isTempDelete,
                    isWorkOrderCreated: item?.isWorkOrderCreated,
                  }),
                )}
                renderActions={renderActions}
                highlightRow={false}
                renderInput={renderInput}
                editableColumns={["Urgent"]}
                removeHeaders={[
                  "isLab",
                  "isDeleteFlag",
                  "serviceId",
                  "id",
                  "testId",
                  "status",
                  "isNew",
                  "isTempDelete",
                ]}
              />
            </div>
          ) : null}
        </>

        <div className="">
          {/* <PathologyModal
            pathologyData={pathologyData}
            setPathologyData={setPathologyData}
            serviceData={serviceData}
            setServiceData={setServiceData}
            dataPathology={dataPathology}
            setDataPathology={setDataPathology}
            editData={editData}
            openPathologyModal={
              openPathologyModal === true ? openPathologyModal : editOpen
            }
            setOpenPathologyModal={setOpenPathologyModal}
            investigationChipsList={investigationChipsList}
            selectedPathology={selectedPathology}
            // selectedAllergieDecription={selectedAllergieDecription}
            // pathologyData={pathologyData}
            // setPathologyData={setPathologyData}
            setSelectedChips={setSelectedChips}
            selectedChips={selectedChips}
            setSelectedPathology={setSelectedPathology}
            data={data}
            setData={setData}
            setEditOpen={setEditOpen}
            edit={edit}
            setEdit={setEdit}
            row={row}
            index={index}
            departmentId={props.patientVisitedDepartmentId}
            setSave={setSave}
            tempDel={tempDel}
            setTempDel={setTempDel}
          /> */}
        </div>
        <div>
          <PastPathology
            patientHistoryData={patientHistoryData}
            setPatientHistoryData={setPatientHistoryData}
            openPastPathology={openPastPathology}
            setOpenPastPathology={setOpenPastPathology}
          />
        </div>
      </div>
    </div>
  );
}
